import { Theme } from '@material-ui/core';

const styles = (theme: Theme) =>
  ({
    homePage: {
      '& h1': {
        textTransform: 'capitalize',
        marginBottom: 20,
        marginTop: 38,
        fontWeight: '200',
      },
    },
    title: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
    },
    contentBloc: {
      display: 'flex',
      '& > div:first-of-type': {
        width: '60%',
        marginRight: 10,
      },
      '& > div:last-of-type': {
        width: '40%',
        marginLeft: 10,
        '& > div': {
          marginBottom: 20,
        },
      },
    },
    illuHome: {
      '& > svg': {
        position: 'fixed',
        bottom: 0,
        width: 400,
        right: 0,
        zIndex: '-1',
        lineHeight: 0,
        '& g:first-of-type': {
          bottom: 0,
          width: 400,
        },
      },
    },
    blocContact: {
      fontSize: 14,
      '& p': {
        fontWeight: 600,
      },
    },

    contactText: {
      display: 'flex',
      alignItems: 'center',
      '& a': {
        color: theme.palette.secondary.main,
        textDecoration: 'none',
        marginRight: 6,
      },
      '& img': {
        marginRight: 6,
      },
    },
    iconStar: {
      '& > path': {
        color: 'white',
      },
    },
    containerButtonDepannage: {
      textAlign: 'center',
      padding: '16px 24px',
    },
    buttonDepannageLabel: {
      display: 'flex',
      flexDirection: 'column',
      '& > svg': {
        '& > g': {
          fill: 'white',
        },
      },
    },
    buttonDepannageTexte: {
      color: theme.palette.secondary.main,
      fontFamily: 'Mulish',
      background: 'white',
      width: '100%',
      padding: '2px 16px',
      marginTop: 8,
      borderRadius: '18px',
      textTransform: 'initial',
      fontSize: 14,
      boxShadow: 'none',
      border: '1px solid white',
      transition: '0.3s ease-in-out',
      '&:hover': {
        background: 'transparent',
        color: 'white',
        boxShadow: 'none',
      },
    },
    containerFidelite: {
      minWidth: 164,
      marginBottom: 20,
      '& h2': {
        fontSize: 39,
        margin: 0,
        fontFamily: 'Poppins',
        fontWeight: '700',
        lineHeight: '12px',
      },
      '& svg': {
        fill: theme.palette.secondary.main,
      },
    },
    // FOND DE CARTE
    containerFondCarte: {
      width: 277,
      height: 175,
      overflow: 'hidden',
      borderRadius: 16,
      boxShadow: '2px 3px 13px -2px #C2C2C2',
    },
    fondCarte: {
      backgroundSize: '100%',
      backgroundRepeat: 'no-repeat',
      width: 292,
      height: 175,
      backgroundPosition: '-8px -8px',
    },
    cardFondCarte: {
      padding: '24px 2px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    containerContentFondCarte: {
      paddingTop: 107,
      width: 277,
      '& > div': {
        padding: '0 6px',
        display: 'flex',
        fontSize: 10,
        '& p': {
          lineHeight: '12px',
          display: 'block',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        },
        '& > p:first-of-type': {
          paddingRight: 2,
          width: '40%',
        },
        '& > p:last-of-type': {
          paddingLeft: 2,
          fontWeight: 600,
          width: '60%',
        },
      },
    },
    contactBloc: {
      '& > div': {
        '& > span': {
          color: theme.palette.primary.main,
        },
      },
    },
    contactAssisteur: {
      display: 'flex',
      flexWrap: 'wrap',

      '& a': {
        color: theme.palette.secondary.main,
        '& > svg': {
          fill: theme.palette.secondary.main,
          marginRight: 4,
          marginBottom: 6,
          width: 20,
        },
      },
    },
    content: { display: 'flex', gap: 20, alignItems: 'flex-start' },
    modaleAjoutAdherent: {
      '& h3': {
        marginBottom: 16,
      },
      '& p': {
        fontSize: 14,
        fontWeight: 'normal',
      },
    },
    modaleInstallApp: {
      '& > h3': {
        marginBottom: 16,
      },
      '& > p': {
        fontSize: 14,
        fontWeight: 'normal',
        color: 'black',
      },
    },
    '@media all and (max-width: 628px)': {
      homePage: {
        '& h1': { fontSize: 27, marginTop: 16 },
      },
      title: {
        flexDirection: 'column',
        '& button': {
          marginTop: -12,
          marginBottom: 16,
          alignSelf: 'stretch',
        },
      },
      content: {
        flexDirection: 'column',
      },
      contentBloc: {
        flexDirection: 'column',
        '& > div:first-of-type': {
          width: '100%',
          marginRight: 0,
          marginBottom: 12,
        },
        '& > div:last-of-type': {
          width: '100%',
          marginLeft: 0,
        },
      },
    },
    menuRed: {
      '& svg': {
        fill: theme.palette.secondary.main,
      },
    },
  } as any);

export default styles;
